import type { ElementChipSelection } from './elementChipsTypes';

export const ELEMENT_CHIP_SELECT = 'ELEMENT_CHIP_SELECT';
export const ELEMENT_CHIP_EDITING_START = 'ELEMENT_CHIP_EDITING_START';
export const ELEMENT_CHIP_EDITING_FINISH = 'ELEMENT_CHIP_EDITING_FINISH';

/**
 * Selects a chip in the generic element chips state.
 */
export const selectElementChip = (chipSelection: ElementChipSelection) => ({
    type: ELEMENT_CHIP_SELECT,
    chipSelection,
});

/**
 * Clears the generic element chip selection.
 */
export const deselectElementChip = () => ({
    type: ELEMENT_CHIP_SELECT,
    chipSelection: null,
});

/**
 * Selects a chip and starts editing it.
 */
export const startEditingElementChip = (chipSelection: ElementChipSelection) => ({
    type: ELEMENT_CHIP_EDITING_START,
    chipSelection,
});

/**
 * Finishes editing a chip without affecting a replacement chip selection.
 */
export const finishEditingElementChip = (chipSelection: ElementChipSelection) => ({
    type: ELEMENT_CHIP_EDITING_FINISH,
    chipSelection,
});

export type ElementChipsAction =
    | ReturnType<typeof selectElementChip>
    | ReturnType<typeof deselectElementChip>
    | ReturnType<typeof startEditingElementChip>
    | ReturnType<typeof finishEditingElementChip>;
